import { render, staticRenderFns } from "./supplier-list.vue?vue&type=template&id=aee77d6a&scoped=true&"
import script from "./supplier-list.vue?vue&type=script&lang=js&"
export * from "./supplier-list.vue?vue&type=script&lang=js&"
import style0 from "./supplier-list.vue?vue&type=style&index=0&id=aee77d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee77d6a",
  null
  
)

export default component.exports